import React, { useContext } from 'react';
import TimeTableContext from '../context/timeTableContext'
import SelectTeacher from '../components/parts/SelectTeacher'
import DateButtons from '../components/parts/DateButtons'
import { createViewTimeTableTeacher, createViewTimeTable, getClassHoursById, getDaysOfWeek } from '../helpers/TimeTableHelpers'

import LessonBox from './lessonBox';


const TimeTableTeacher = () => {
    const context = useContext(TimeTableContext);

    let daysOfWeek = getDaysOfWeek(context);
    let classTimeTable = createViewTimeTableTeacher(context);
    let timeDictonary;
    let daysOfWeekHead = [];
    for (let i = context.state.firstDay; i <= daysOfWeek.length - 1; i++) {
        console.log(<th key={i} style={{ width: "16.66%" }}>{daysOfWeek[i]}- {context.state.allWeek[i]}</th>);
        daysOfWeekHead.push(<th key={i} style={{ width: "16.66%" }}>{daysOfWeek[i]}- {context.state.allWeek[i]}</th>)
    }

    if (context.state.useSlotLabels) {
        timeDictonary = getClassHoursById(context.state)
    }

    return (
        <div className="container-fluid">
            <SelectTeacher />
            <DateButtons />
            <hr />
            <table className="table table-bordered table-responsive">
                <thead className="thead-dark">
                    <tr>
                        <th style={{ width: "2%" }}>שעה</th>
                        {
                            daysOfWeekHead
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        classTimeTable.map((ttClassO, key) => {
                            let hourInTable = context.state.useSlotLabels && timeDictonary !== undefined && timeDictonary[key].start !== undefined ? timeDictonary[key].start : (key + context.state.firstHour)
                            return (
                                <tr key={key}>
                                    <td key={key}>{hourInTable}</td>
                                    {
                                        ttClassO.map((ttClassInfo, key) => {

                                            return (
                                                <td key={key}>
                                                    {
                                                        ttClassInfo.map((fullInfo, key) => {

                                                            return (
                                                                <LessonBox key={key} data={fullInfo} />
                                                            )
                                                        })
                                                    }

                                                </td>

                                            )
                                        }
                                        )
                                    }
                                </tr>
                            )
                        }


                        )
                    }
                </tbody>
            </table>
        </div>

    );
}

export default TimeTableTeacher;